import React, { useState, useEffect, useRef } from 'react';
import { AiOutlineMenu } from 'react-icons/ai';
import figure5 from "../../../assets/Trabajador.png";
import '../../../../src/index.css';
import figure6 from "../../../assets/images/icons/menu/lectorQR.svg";
import figure7 from "../../../assets/images/icons/menu/tablero.svg";
import figure8 from "../../../assets/images/icons/menu/lista.svg";
import figure9 from "../../../assets/images/icons/menu/historico.svg";
import figure10 from "../../../assets/images/icons/menu/reportes.svg";
import figure11 from "../../../assets/images/logos/logoTasaBalanza.svg";
import figure12 from "../../../assets/images/icons/menu/configuracion.svg";
import figure13 from "../../../assets/images/icons/menu/administracion.svg";
import { useNavigate } from 'react-router-dom';
import Programate from '../footer';
import { useAuth } from '../../../components/authentication/Auth/index';

const Menu = ({ isMenuOpen, toggleMenu }) => {
  const [isMalabrigoDropdownOpen, setIsMalabrigoDropdownOpen] = useState(false);
  const [isAdministracionDropdownOpen, setIsAdministracionDropdownOpen] = useState(false);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [activeOption, setActiveOption] = useState(null);
  const [userData, setUserData] = useState(null);

  const navigate = useNavigate();
  const menuRef = useRef(null); // Referencia para el menú
  const menuButtonRef = useRef(null); // Referencia para el botón del menú

  const { logout } = useAuth();

  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    console.log("storedUser:", typeof storedUser);
    if (storedUser) {
      setUserData(JSON.parse(storedUser));
    }
  }, []);

  const handleOptionClick = (itemText, path) => {
    setActiveOption(itemText);

    // Si el usuario hace clic en "Cerrar sesión", llama a la función logout
    if (itemText === "Cerrar sesión") {
      logout(); // Cierra la sesión de MSAL
      navigate("/"); // Redirige al usuario a la página de inicio de sesión
    } else {
      navigate(path); // Navega a la ruta correspondiente
    }
  };

  const handleAdministracionClick = () => {
    setActiveOption("Administración");
    setIsAdministracionDropdownOpen(!isAdministracionDropdownOpen);
  };

  const handleResize = () => {
    const newWidth = window.innerWidth;
    setScreenWidth(newWidth);

    // Cerrar el menú automáticamente en móviles y tablets
    if (newWidth < 1024 && isMenuOpen) {
      toggleMenu(false);
    }
    // Abrir el menú automáticamente solo en pantallas grandes (> 1200px)
    else if (newWidth > 1024 && !isMenuOpen) {
      toggleMenu(true);
    }
  };

  useEffect(() => {
    handleResize(); // Ejecutar al montar el componente
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    if (screenWidth < 1024 && isMenuOpen) {
      const handleClickOutside = (event) => {
        // Cerrar el menú si el clic es fuera del menú y no es el botón del menú
        if (
          menuRef.current &&
          !menuRef.current.contains(event.target) &&
          !menuButtonRef.current.contains(event.target)
        ) {
          toggleMenu(false);
        }
      };

      document.addEventListener('click', handleClickOutside);
      return () => document.removeEventListener('click', handleClickOutside);
    }
  }, [screenWidth, isMenuOpen, toggleMenu]); // Dependencias actualizadas

  const toggleMalabrigoDropdown = () => setIsMalabrigoDropdownOpen(!isMalabrigoDropdownOpen);

  const menuItems = [
    { icon: figure6, text: "Lector QR", path: "/ingresoQR" },
    { icon: figure7, text: "Tablero", path: "/tablero" },
    //{ icon: figure8, text: "Lista", path: "/lista" },
    { icon: figure9, text: "Histórico", path: "/historico" },
    { icon: figure13, text: "Administración", isAdmin: true },
    { icon: figure10, text: "Reportes", path: "/reportes" },
  ];

  return (
    <div className="relative">
      <div className={`fixed top-0 left-0 w-full bg-[#007696] text-white h-[90px] p-4 flex justify-between items-center z-20`}>
        <div className={`flex items-center transition-all malabrigo-name ${isMenuOpen && screenWidth >= 1024 ? 'pl-[220px]' : 'pl-4 '}`}>
          <div className="flex items-center space-x-4">
            {/* Asignar menuButtonRef al botón del menú */}
            <button ref={menuButtonRef} onClick={toggleMenu} className="text-2xl">
              <AiOutlineMenu />
            </button>

            <button onClick={toggleMalabrigoDropdown} className="text-[16px] md:text-[24px] font-bold flex items-center">
              <span>Malabrigo</span>
              {!isMalabrigoDropdownOpen && (
                <div className="ml-2 mt-1 w-0 h-0 border-l-[6px] border-r-[6px] border-t-[6px] border-transparent border-t-white" />
              )}
              {isMalabrigoDropdownOpen && (
                <div className={`absolute sm:pt-8 xl:pt-7 top-14 w-[147px] xl:w-[191px] text-[16px] font-itcbold bg-[#007696] text-white shadow-md rounded-lg z-40`}>
                  {["Chimbote", "Samanco", "Supe", "Vegueta", "Pisco Sur", "Pucusana", "Callao Norte", "Matarani"].map((option, index) => (
                    <React.Fragment key={index}>
                      <button
                        onClick={() => console.log(option)}
                        className="block w-full px-4 py-1 text-left font-itcdemi"
                      >
                        {option}
                      </button>
                      {index < 7 && <hr className="border-t" />}
                    </React.Fragment>
                  ))}
                </div>
              )}
            </button>
          </div>
        </div>

        <div className="flex items-center space-x-6">
          <div className="text-right">
            <h2 className="text-lg font-bold md:text-xl">
              {userData?.name || 'Nombre de usuario'}
            </h2>
            <p className="text-sm md:text-base">Administrador</p>
          </div>
          <img src={figure5} alt="Trabajador" className="w-12 h-12 rounded-full md:w-25 xl:w-14" />
        </div>
      </div>

      {isMenuOpen && (
        <div className="fixed inset-0 z-10 bg-black opacity-50 lg:opacity-0 xl:hidden" />
      )}

      {/* Asignar menuRef al contenedor del menú */}
      <div
        ref={menuRef}
        className={`fixed top-0 left-0 overflow-y-auto scroll-menu h-full bg-[#007696] text-white transition-all duration-300 ease-in-out ${isMenuOpen ? 'w-[220px] ' : 'w-0'} overflow-hidden z-50 flex flex-col justify-between`}
      >

        <div className="flex flex-col justify-center space-y-2">
          <div className=" ml-4 h-[90px] py-4 cursor-pointer  md:ml-6 ">
            <img src={figure11} alt="Cerrar" onClick={toggleMenu} />
          </div>

          {menuItems.map((item, index) => (
            <React.Fragment key={index}>
              <div
                className={`flex items-center justify-center pl-8  cursor-pointer ${activeOption === item.text ? "bg-[#184A7D]" : " bg-[#007696]"} p-2 transition w-[100%] hover:bg-[#184A7D]`}
                onClick={() => item.isAdmin ? handleAdministracionClick() : handleOptionClick(item.text, item.path)}
              >
                <div className='w-[20%]'>
                  <img src={item.icon} alt={`figure${index + 6}`} />
                </div>
                <div className='w-[80%]'>
                  <span className="block text-[16px] font-itcmedium ">
                    {item.text}
                  </span>
                </div>
              </div>
              {item.isAdmin && isAdministracionDropdownOpen && (
                <div className="pl-[1.7rem] space-y-1 w-[100%]">
                  {[{ text: "Plantas", path: "/plantas" }, { text: "Balanzas", path: "/balanzas" }, { text: "Modelo de Balanzas", path: "/modelo-balanzas" }, { text: "Marca de Balanzas", path: "/marca-balanzas" }, { text: "Productos", path: "/productos" }, { text: "Categoria de Productos", path: "/categoria-productos" }].map((option, optionIndex) => (
                    <div
                      key={optionIndex}
                      className={`cursor-pointer ${activeOption === option.text ? "bg-[#184A7D]" : "bg-[#007696]"} p-1 transition w-full`}
                      onClick={(e) => {
                        e.stopPropagation();
                        handleOptionClick(option.text, option.path);
                      }}
                    >
                      <span className="block text-[14px]  font-itcbook ">
                        {option.text}
                      </span>
                    </div>
                  ))}
                </div>
              )}
            </React.Fragment>
          ))}
        </div>

        <div className="mb-4 space-y-2">
          <div className='flex justify-center'>
            <div className="w-full mx-[10%] my-4 border-t border-white"></div>
          </div>

          <div
            className={`flex items-center p-2 cursor-pointer justify-center ${activeOption === "Configuración" ? "bg-[#184A7D]" : " bg-[#007696]"} hover:bg-[#184A7D]`}
            onClick={() => handleOptionClick("Configuración", "/configuracion")}
          >
            <img src={figure12} alt="Configuración" className="pr-4" />
            <span className="block text-[12px] md:text-[16px] font-itcmedium ">
              Configuración
            </span>
          </div>

          <div
            className={`flex items-center p-2 justify-center cursor-pointer ${activeOption === "Cerrar sesión" ? "bg-[#184A7D]" : ""} hover:bg-[#184A7D]`}
            onClick={() => handleOptionClick("Cerrar sesión", "/cerrar-sesion")}
          >
            <span className="block text-[12px] md:text-[16px] font-itcmedium ">
              Cerrar Sesión
            </span>
          </div>

        </div>
      </div>
    </div>
  );
};

export default Menu;